import { createAsyncThunk } from "@reduxjs/toolkit";
//Include Both Helper File with needed methods
import { getAppsData as getAppsDataApi } from "../../helpers/backend_helper";

export const getAppsData = createAsyncThunk(
  "dashboard/getAppsData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAppsDataApi();
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
